import GeniusSiteTracking from "app/components/GeniusTracking/GeniusSiteTracking";
import React, { lazy, Suspense, useEffect, useState } from "react";
import { connect } from "react-redux";
import { SessionHelper } from "../../helpers/sessionHelper";
import PublicCTA from "./components/PublicCTA/PublicCTA";
import PublicShowcase from "./components/PublicShowcase/PublicShowcase";
import PublicWork from "./components/PublicWork/PublicWork";
import "./PublicScreen.scss";

const PublicHero = lazy(() => import("./components/PublicHero/PublicHero"));
const CookieConfirmation = lazy(
  () => import("./components/CookieConfirmation/CookieConfirmation")
);
const Footer = lazy(() => import("../PublicScreen/components/Footer/Footer"));
const PublicFeatures = lazy(
  () => import("./components/PublicFeatures/PublicFeatures")
);

type Props = {
  history: any;
  showNotificationDisplay: boolean;
};

const PublicScreen: React.FC<Props> = ({
  history,
  showNotificationDisplay,
}) => {
  const [showCookieConfirmation, setShowCookieConfirmation] = useState(true);

  const onClickAcceptCookies = () => {
    setShowCookieConfirmation(false);
  };

  const onClickDeclineCookies = () => {
    setShowCookieConfirmation(false);
  };

  useEffect(() => {
    // componentDidMount equivalent
    // You can perform any side effects here
    // For example, dispatching actions or fetching data
    // Remember to return a cleanup function if needed
    return () => {
      // componentWillUnmount equivalent
      // Clean up any resources or subscriptions here
    };
  }, []);

  return (
    <div
      className="public__screen"
      style={{
        paddingTop: showNotificationDisplay ? "132px" : "72px",
      }}
    >
      <GeniusSiteTracking
        targetSelector=".public__screen"
        eventType="change"
        pageName="homepage"
        trackPageLoad={true}
      />
      {/* add genius component here, when users land here we can track user count? */}
      <Suspense fallback={<div className="fallback">loading...</div>}>
        <PublicHero />
      </Suspense>
      <PublicShowcase />
      <Suspense fallback={<div className="fallback">loading...</div>}>
        <PublicFeatures />
      </Suspense>
      <PublicCTA />
      <PublicWork />
      <Suspense fallback={<div className="fallback">loading...</div>}>
        <Footer />
      </Suspense>
      <Suspense fallback={<div className="fallback">loading...</div>}>
        {showCookieConfirmation &&
          SessionHelper.checkAcceptCookieTerms() !==
            "accepted-cookie-terms" && (
            <CookieConfirmation
              onClickAccept={onClickAcceptCookies}
              onClickDecline={onClickDeclineCookies}
            />
          )}
      </Suspense>
    </div>
  );
};

const mapStateToProps = state => ({
  showNotificationDisplay: state.notificationListModel.showNotificationDisplay,
});

const mapDispatchToProps = dispatch => ({
  loadNotifications: () => {
    dispatch.notificationListModel.loadNotificationList();
  },
  setNotificationPlatform: platform => {
    dispatch.notificationListModel.setPlatform(platform);
  },
  purgeBetSlipList: () => {
    dispatch.betSlipListModel.purgeBetSlipList();
  },
  login: (username, password) =>
    dispatch.sessionModel.loginUser({
      username,
      password,
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(PublicScreen);
